import { useQuery, useQueryClient } from '@tanstack/react-query'
import { getPositionTemplates } from 'api/company/positionTemplates'
import { useAuthContext } from 'components/auth/useAuthContext'
import { positionTemplatesKey } from 'queries/company/keys'

export function useCompanyPositionTemplates() {
  const { company } = useAuthContext()

  return useQuery({
    queryKey: positionTemplatesKey,
    queryFn: () => {
      const companyId = company?.id
      if (!companyId) {
        throw new Error('Company ID not found')
      }

      return getPositionTemplates(companyId)
    },
    enabled: Boolean(company?.id),
  })
}

export function useInvalidateCompanyPositionTemplates() {
  const queryClient = useQueryClient()

  return {
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: positionTemplatesKey,
      }),
  }
}
